<template>
<!-- 蓝牙/网络升级任务查看 -->
  <div class="model-page">
    <el-descriptions>
      <el-descriptions-item :label="$t('pages.equipment.text5')">{{
        formalUpgradeInfo.bikeCategoryName
      }}</el-descriptions-item>
      <el-descriptions-item :label="$t('pages.equipment.text6')">{{
        formalUpgradeInfo.bikeTypeName
      }}</el-descriptions-item>
      <el-descriptions-item :label="$t('pages.equipment.text25')">{{
        formalUpgradeInfo.totalNum
      }}</el-descriptions-item>
      <el-descriptions-item :label="$t('pages.equipment.text254')">{{
        formalUpgradeInfo.upgradeType == 1
          ? $t("pages.equipment.text178")
          : "4g"
      }}</el-descriptions-item>
      <el-descriptions-item :label="$t('pages.equipment.text249')">{{
        formalUpgradeInfo.isForce == 0
          ? $t("pages.equipment.text193")
          : $t("pages.equipment.text194")
      }}</el-descriptions-item>
      <el-descriptions-item :label="$t('pages.equipment.text191')">{{
        formalUpgradeInfo.startValidTime
      }}</el-descriptions-item>
      <el-descriptions-item :label="$t('omission.text10')">{{
        formalUpgradeInfo.upgradeIntro
      }}</el-descriptions-item>
    </el-descriptions>
    <!-- 表格 -->
    <DiluTable
      :list="[formalUpgradeInfo]"
      :tableConfig="tableConfig"
      style="margin-top: 30px"
    >
      <el-table-column
        prop="hwType"
        :label="$t('pages.equipment.text198')"
        width="130"
        align="center"
      >
        <template slot-scope="scope">
          <div v-for="(item, index) in hwTypeList" :key="index">
            <div v-if="scope.row.hwType == item.value">
              {{ item.label }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="hwVersion"
        :label="$t('pages.equipment.text214')"
        width="150"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="fwVersion"
        :label="$t('pages.equipment.text201')"
        width="150"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="fileSize" :label="$t('omission.text4')" width="130" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.fileSize }}kb</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="firmwareName"
        :label="$t('pages.equipment.text200')"
        align="center"
      >
      </el-table-column>
    </DiluTable>
    <!-- 统计图 -->
    <div class="situation-model">
      <div id="situation"></div>
    </div>
  </div>
</template>


<script>
import DiluTable from "../../../../components/pubilc/dilu-table.vue";
import * as echarts from "echarts";
export default {
  data() {
    return {
      tableConfig: {
        isTree: false,
        isPage: false,
      },
      hwTypeList: [
        {
          label: this.$t("pages.equipment.text178"),
          value: 10,
        },
        {
          label: this.$t("pages.equipment.text202"),
          value: 15,
        },
        {
          label: this.$t("pages.equipment.text203"),
          value: 20,
        },
        {
          label: this.$t("pages.equipment.text204"),
          value: 25,
        },
        {
          label: this.$t("pages.equipment.text205"),
          value: 30,
        },
        {
          label: this.$t("pages.equipment.text206"),
          value: 35,
        },
        {
          label: this.$t("pages.equipment.text207"),
          value: 40,
        },
        {
          label: this.$t("pages.equipment.text208"),
          value: 45,
        },
      ],
    };
  },
  watch: {
    activeName: {
      handler(val) {
        if (val) {
          setTimeout(()=>{
            this.initSituationModel();
          },500);
        }
      },
    },
  },
  props: ["formalUpgradeInfo", "activeName"],
  methods: {
    //升级情况
    initSituationModel() {
      var chartDom = document.getElementById("situation");
      var myChart = echarts.init(chartDom);
      let arr = this.formalUpgradeInfo.upgradeStatusBeanList;
      let that = this;
      let echartsData = [];
      for (let i in arr) {
        if (arr[i].upgradeStatus == 0) {
          if (arr[i].num != 0) {
            echartsData.push({
              value: arr[i].num,
              name: this.$t("pages.equipment.text233"),
              itemStyle: { color: "#46E1EC" },
            });
          }
        }
        if (arr[i].upgradeStatus == 1) {
          if (arr[i].num != 0) {
            echartsData.push({
              value: arr[i].num,
              name: this.$t("pages.equipment.text232"),
              itemStyle: { color: "#1F5BCC" },
            });
          }
        }
        if (arr[i].upgradeStatus == 2) {
          if (arr[i].num != 0) {
            echartsData.push({
              value: arr[i].num,
              name: that.$t("omission.text7"),
              itemStyle: { color: "#FF6969" },
            });
          }
        }
        if (arr[i].upgradeStatus == 3) {
          if (arr[i].num != 0) {
            echartsData.push({
              value: arr[i].num,
              name: that.$t("omission.text8"),
              itemStyle: { color: "#D7DDEB" },
            });
          }
        }
        if (arr[i].upgradeStatus == 4) {
          if (arr[i].num != 0) {
            echartsData.push({
              value: arr[i].num,
              name: that.$t("omission.text9"),
              itemStyle: { color: "#F2B455" },
            });
          }
        }
      }
      var option;
      option = {
        tooltip: {
          trigger: "item",
        },
        title: {
          text: that.$t("omission.text12"),
          left: "center",
          top: "10%",
        },
        legend: {
          bottom: "10%",
          left: "center",
          icon: "circle",
        },
        series: [
          {
            type: "pie",
            radius: ["30%", "60%"],
            title: that.$t("omission.text12"),
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "16",
                fontWeight: "bold",
              },
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  //自定义颜色
                  var colorList = [
                    "#1F5BCC",
                    "#46E1EC",
                    "#D7DDEB",
                    "#FF6969",
                    "#F2B455",
                  ];
                  return colorList[params.dataIndex];
                },
              },
            },
            labelLine: {
              show: false,
            },
            data: echartsData,
          },
        ],
      };
      option && myChart.setOption(option);
    },
  },
  components: {
    DiluTable,
  },
};
</script>

<style scoped>
.model-page {
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.situation-model {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #ededed;
}
#situation {
  width: 100%;
  height: 100%;
  flex-shrink: 0;
}
</style>